"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdnamiAd = exports.isNativeAd = exports.isBannerAd = void 0;
function isBannerAd(adObj) {
    return adObj.adType === 'banner';
}
exports.isBannerAd = isBannerAd;
function isNativeAd(adObj) {
    return adObj && adObj.adType === 'native';
}
exports.isNativeAd = isNativeAd;
function isAdnamiAd(adObj) {
    var _a, _b, _c, _d, _e, _f;
    return (((adObj === null || adObj === void 0 ? void 0 : adObj.adType) === 'banner' && (adObj === null || adObj === void 0 ? void 0 : adObj.width) === 1 && (adObj === null || adObj === void 0 ? void 0 : adObj.height) === 2) ||
        (((_a = adObj === null || adObj === void 0 ? void 0 : adObj.banner) === null || _a === void 0 ? void 0 : _a.width) === 1 && ((_b = adObj === null || adObj === void 0 ? void 0 : adObj.banner) === null || _b === void 0 ? void 0 : _b.height) === 2) ||
        ((_d = (_c = adObj === null || adObj === void 0 ? void 0 : adObj.banner) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.includes('adnm')) ||
        ((_f = (_e = adObj === null || adObj === void 0 ? void 0 : adObj.banner) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f.includes('adnami')));
}
exports.isAdnamiAd = isAdnamiAd;
